//values

document.addEventListener("DOMContentLoaded", function () {
  // detect iOS Safari
  const ua = window.navigator.userAgent;
  const ios = /iPad|iPhone/i.test(ua);
  const webkit = /WebKit/i.test(ua);
  const iossafari = ios && webkit && !/CriOS/i.test(ua);

  // add class if iOS Safari
  if (iossafari) {
    document.body.classList.add("software-iossafari");
  }

  // toggle nav icon and menu
  const navIcon = document.getElementById("nav-icon1");
  if (navIcon) {
    navIcon.addEventListener("click", function () {
      this.classList.toggle("open");
      const menuWrap = document.querySelector(".menu-dwn-wrap");
      if (menuWrap) {
        menuWrap.classList.toggle("active");
      }
    });
  }

  // trigger live chat button
  const chatButtons = document.querySelectorAll(".lchtbtn");
  chatButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const liveInvite = document.querySelector(".livesdk__invitation");
      if (liveInvite) {
        liveInvite.click();
      }
    });
  });
});

//functions
let serialize_form = function(form) {

  //values
	var obj = {};
	var formData = new FormData(form);

  //for
	for (var key of formData.keys()) {

    //set
		obj[key] = formData.get(key);
    
	}

  //return
	return obj;

}
